import React from "react";

const WavesBackground = ({ color = "currentColor", className = "" }) => {
  const svgClass = className || "w-full h-auto";
  return (
    <svg className={svgClass} viewBox="0 0 410 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M1 32.0676C1 32.0676 65.5832 65.8869 110.805 64.5164C177.071 62.508 212.449 -6.35602 278.203 1.64682C335.754 8.65122 409 68.0655 409 68.0655"
        stroke={color}
      />
      <path
        d="M1 85.9506C1 85.9506 65.5832 119.77 110.805 118.399C177.071 116.391 223.753 33.1909 289.507 41.1938C347.057 48.1982 409 81.2477 409 81.2477"
        stroke={color}
      />
      <path
        d="M1 65.6702C1 65.6702 62.8919 94.2796 108.113 92.9091C174.38 90.9007 224.829 15.4455 290.583 23.4484C348.134 30.4528 406.847 73.1356 406.847 73.1356"
        stroke={color}
      />
    </svg>
  );
};

export default WavesBackground;
